import { search } from '@debbie/common/dist/util/index.js';
import { computePosition, flip, shift } from '@floating-ui/dom';
import { ReactRenderer, posToDOMRect } from '@tiptap/react';
import MentionList from './MentionList.js';
const updatePosition = (editor, element) => {
    const virtualElement = {
        getBoundingClientRect: () => posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to),
    };
    computePosition(virtualElement, element, {
        placement: 'bottom-start',
        strategy: 'absolute',
        middleware: [shift(), flip()],
    }).then(({ x, y, strategy }) => {
        element.style.width = 'max-content';
        element.style.position = strategy;
        element.style.left = `${x}px`;
        element.style.top = `${y}px`;
    });
};
export default (itemsRef) => ({
    items: ({ query }) => {
        return search(itemsRef.current, (x) => x.label, query, {}); //.slice(0, 5)
    },
    render: () => {
        let component = null;
        const destroyComponent = () => {
            component?.element.remove();
            component?.destroy();
            component = null;
        };
        return {
            onStart: (props) => {
                component = new ReactRenderer(MentionList, {
                    props,
                    editor: props.editor,
                });
                if (!props.clientRect) {
                    return;
                }
                component.element.style.position = 'absolute';
                component.element.style.zIndex = '100000';
                document.body.appendChild(component.element);
                updatePosition(props.editor, component.element);
            },
            onUpdate(props) {
                if (!component) {
                    return;
                }
                component.updateProps(props);
                if (!props.clientRect) {
                    return;
                }
                updatePosition(props.editor, component.element);
            },
            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    destroyComponent();
                    return true;
                }
                return component?.ref?.onKeyDown(props) ?? false;
            },
            onExit() {
                destroyComponent();
            },
        };
    },
});
//# sourceMappingURL=suggestion.js.map